import { flexRender, Header } from '@tanstack/react-table';
import { ChangeEvent } from 'react';
import { RadioButton, RadioGroup } from '../../../../Radio';
import { BoolFilterType, BoolOptions, ColumnFilter } from '../../../types';
import { FilterContainer, FilterLabel } from '../styles';

interface TableColumnBoolFilterProps<T> {
    header: Header<T, unknown>;
    setColumnFilter: (value?: ColumnFilter) => void;
    selectedValue: boolean | undefined;
    getBoolOptions: () => BoolOptions;
}

export const TableColumnBoolFilter = <T,>({
    getBoolOptions,
    header,
    selectedValue,
    setColumnFilter,
}: TableColumnBoolFilterProps<T>) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const radioValue = event.target.value;
        const filter =
            radioValue === 'undefined'
                ? undefined
                : { filterType: BoolFilterType.Equals, value: radioValue === 'true' };
        setColumnFilter(filter);
    };

    const { meta, header: columnHeading } = header.column.columnDef;
    const options = getBoolOptions();

    return (
        <FilterContainer vertical spacing="100">
            {meta?.showHeaderInColumnFilter ? (
                <FilterLabel>{flexRender(columnHeading, header.getContext())}</FilterLabel>
            ) : null}
            <RadioGroup onChange={handleChange} value={String(selectedValue)}>
                <RadioButton label={options.undefined} value="undefined" />
                <RadioButton label={options.true} value="true" />
                <RadioButton label={options.false} value="false" />
            </RadioGroup>
        </FilterContainer>
    );
};
